<template>
  <OperativeTable :dense="dense">
    <OperativeTableHeader :years="yearsTableHeadings" />
    <tbody>
      <OperativeTableBodyRow :values="yearsTableRows.utileEsercizio">
        Utile d'esercizio
        <template #cell-content="{ value }">{{ value | money }}</template>
      </OperativeTableBodyRow>
      <OperativeTableBodyRow :values="yearsTableRows.ammortamenti">
        Ammortamenti
        <template #cell-content="{ value }">{{ value | money }}</template>
      </OperativeTableBodyRow>
      <OperativeTableBodyRow :values="yearsTableRows.oneriFinanziari">
        Oneri finanziari
        <template #cell-content="{ value }">{{ value | money }}</template>
      </OperativeTableBodyRow>
      <OperativeTableBodyRow :values="yearsTableRows.deltaFondi">
        ∆ Fondi
        <template #cell-content="{ value }">{{ value | money }}</template>
      </OperativeTableBodyRow>
      <OperativeTableBodyRow :values="yearsTableRows.currentCashFlow" strong>
        Current Cash Flow
        <template #cell-content="{ value }">{{ value | money }}</template>
      </OperativeTableBodyRow>

      <OperativeTableBodyRow :values="yearsTableRows.deltaLiquiditaDiff">
        ∆ Liquidità differite
        <template #cell-content="{ value }">{{ value | money }}</template>
      </OperativeTableBodyRow>
      <OperativeTableBodyRow :values="yearsTableRows.deltaCreditoImposta">
        ∆ Credito d'imposta
        <template #cell-content="{ value }">{{ value | money }}</template>
      </OperativeTableBodyRow>
      <OperativeTableBodyRow :values="yearsTableRows.deltaDebitiCommerciali">
        ∆ Debiti commerciali
        <template #cell-content="{ value }">{{ value | money }}</template>
      </OperativeTableBodyRow>
      <OperativeTableBodyRow :values="yearsTableRows.deltaAltriDebiti">
        ∆ Altri debiti
        <template #cell-content="{ value }">{{ value | money }}</template>
      </OperativeTableBodyRow>
      <OperativeTableBodyRow :values="yearsTableRows.deltaRisconti">
        ∆ Risconti
        <template #cell-content="{ value }">{{ value | money }}</template>
      </OperativeTableBodyRow>
      <OperativeTableBodyRow :values="yearsTableRows.operatingCashFlow" strong>
        Operating Cash Flow
        <template #cell-content="{ value }">{{ value | money }}</template>
      </OperativeTableBodyRow>

      <OperativeTableBodyRow :values="yearsTableRows.investimenti">
        Investimenti
        <template #cell-content="{ value }">{{ value | money }}</template>
      </OperativeTableBodyRow>
      <OperativeTableBodyRow :values="yearsTableRows.freeCashFlow" strong>
        Free Cash Flow
        <template #cell-content="{ value }">{{ value | money }}</template>
      </OperativeTableBodyRow>

      <OperativeTableBodyRow :values="yearsTableRows.deltaBancheMLTermine">
        ∆ Banche M/L Termine
        <template #cell-content="{ value }">{{ value | money }}</template>
      </OperativeTableBodyRow>
      <OperativeTableBodyRow :values="yearsTableRows.deltaBanche">
        ∆ Banche
        <template #cell-content="{ value }">{{ value | money }}</template>
      </OperativeTableBodyRow>
      <OperativeTableBodyRow :values="yearsTableRows.deltaAltriDebitiFinanziari">
        ∆ Altri debiti finanziari
        <template #cell-content="{ value }">{{ value | money }}</template>
      </OperativeTableBodyRow>
      <OperativeTableBodyRow :values="yearsTableRows.oneriFinanziari2">
        Oneri finanziari
        <template #cell-content="{ value }">{{ value | money }}</template>
      </OperativeTableBodyRow>
      <OperativeTableBodyRow :values="yearsTableRows.deltaPn">
        ∆ PN
        <template #cell-content="{ value }">{{ value | money }}</template>
      </OperativeTableBodyRow>
      <OperativeTableBodyRow :values="yearsTableRows.flussoGestioneComplessiva" strong>
        Flusso della gestione complessiva
        <template #cell-content="{ value }">{{ value | money }}</template>
      </OperativeTableBodyRow>

      <OperativeTableBodyRow :values="yearsTableRows.deltaLiquiditaImmediate">
        ∆ Liquidità immediate
        <template #cell-content="{ value }">{{ value | money }}</template>
      </OperativeTableBodyRow>

      <OperativeTableBodyRow :values="yearsTableRows.flussoCircolanteNetto" strong>
        Flusso circolante netto
        <template #cell-content="{ value }">{{ value | money }}</template>
      </OperativeTableBodyRow>

      <OperativeTableBodyRow :values="yearsTableRows.DSCRCategory">
        Indicatore di crisi
        <template #cell-content="{ value }">
          <Semaphore :value="value" :label="value | alarm" />
          {{ value | alarm }}
        </template>
      </OperativeTableBodyRow>
    </tbody>
  </OperativeTable>
</template>

<script>

import computedFinancialDataMixin from '@/mixins/computedFinancialData.js';
import operativePageMixin from '@/mixins/operativePage.js';
import formatMoneyFilter from '@/filters/formatMoney.js';
import formatAlert from '@/filters/formatAlert.js';
import Semaphore from '@/views/components/Operative/Semaphore';

export default {
  mixins: [operativePageMixin, computedFinancialDataMixin],
  components: {
    OperativeTable: () => import('@/views/components/Operative/OperativeTable.vue'),
    OperativeTableBodyRow: () => import('@/views/components/Operative/OperativeTableBodyRow.vue'),
    OperativeTableHeader: () => import('@/views/components/Operative/OperativeTableHeader.vue'),
    Semaphore,
  },
  filters: {
    money: formatMoneyFilter,
    alarm: formatAlert,
  },
  props: {
    yearsTableRows: {
      default: null,
      type: Object,
    },
    yearsTableHeadings: {
      default: null,
      type: Array,
    },
    dense: {
      default: false,
      type: Boolean,
    },
    isModuleSubsidizedFinanceEnabled: {
      default: false,
      type: Boolean,
    },
  },
};

</script>
